/* EVENTS INVOLVING USER MANAGEMENT */

export default {
  users_tab_edit_visit: {
    // visit the user edit modal
    excludeSuperAdmin: true,
    getProps: ({ editedUser }) => {
      return {
        editedUserId: editedUser?.id,
        editedUserEmail: editedUser?.email,
      };
    },
  },
  users_tab_visit: {
    // visit the users tab by clicking on the sidebar
    excludeSuperAdmin: true,
    getProps: ({ editedUser }) => {
      return {
        editedUserId: editedUser?.id,
        editedUserEmail: editedUser?.email,
      };
    },
  },
  users_tab_edit_close: {
    // close the user edit modal without saving
    excludeSuperAdmin: true,
    getProps: ({ editedUser }) => {
      return {
        editedUserId: editedUser?.id,
        editedUserEmail: editedUser?.email,
      };
    },
  },
};
